import * as React from 'react';

import { Announcements } from '@/components/Announcements';
import { PinnedPost } from '@/components/Post/PinnedPost';
import { PostFeed } from '@/components/PostFeed';
import { CreatePostButton } from '@/components/create-post/CreatePostButton';

type IGroupActivityPaneParams = {
  groupId: string;
  groupName: string;
  canCreatePostInGroup: boolean;
};

export const GroupActivityPaneContent: React.FC<IGroupActivityPaneParams> = (
  props
) => {
  return (
    <React.Fragment>
      {props.canCreatePostInGroup && (
        <CreatePostButton
          group={{ _id: props.groupId, name: props.groupName }}
          showFixedGroupName={true}
          mb="4"
        />
      )}
      <Announcements mb="4" groupId={props.groupId} />
      <PinnedPost mb="4" groupId={props.groupId} />
      <PostFeed groupId={props.groupId} excludePinned />
    </React.Fragment>
  );
};
